/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PeriodicQaCheck } from '../../models/periodic-qa-check';

export interface GetActivePeriodicCheck$Params {
  productionOrderId: number;
}

export function getActivePeriodicCheck(http: HttpClient, rootUrl: string, params: GetActivePeriodicCheck$Params, context?: HttpContext): Observable<StrictHttpResponse<PeriodicQaCheck>> {
  const rb = new RequestBuilder(rootUrl, getActivePeriodicCheck.PATH, 'get');
  if (params) {
    rb.path('productionOrderId', params.productionOrderId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PeriodicQaCheck>;
    })
  );
}

getActivePeriodicCheck.PATH = '/api/v1/QaCheck/{productionOrderId}/GetActivePeriodicCheck';
